<template>
    <div id="app">
        <div id='bg-img'>
            <el-main class="main-class">
                <el-row type="flex" class="front" justify="center" align="middle">
                    <el-col :span="8" style="height:65%;">
                        <el-form class="login_container">
                            <h1 class="login_title">柚子后台管理系统</h1>
                            <el-form-item>
                                <el-input type="text" v-model="loginForm.account" auto-complete="off"
                                          @keyup.enter.native="login" placeholder="账号"></el-input>
                            </el-form-item>
                            <el-form-item>
                                <el-input type="password" v-model="loginForm.password" auto-complete="off"
                                          @keyup.enter.native="login" placeholder="密码"></el-input>
                            </el-form-item>
                            <el-form-item>
                                <el-button style="width: 100%; background: #505458; border: none" type="primary"
                                           v-on:click="login">登录
                                </el-button>
                            </el-form-item>
                        </el-form>
                    </el-col>
                </el-row>
            </el-main>
        </div>
    </div>
</template>

<script>
import {userLogin} from '@/http/api'

export default {
    name: "Login",
    data() {
        return {
            loginForm: {
                account: '',
                password: ''
            },
        }
    },
    methods: {
        login() {
            let _this = this;
            userLogin({
                account: this.loginForm.account,
                password: this.loginForm.password
            }).then(resp => {
                if (resp.data.status === 0) {
                    _this.$store.commit('login', resp.data.info);
                    _this.$store.commit('changeLoginFlag', 0);
                    let redirectPath = '/'
                    let menuName = null
                    if(resp.data.info != null && resp.data.info.menus != null){
                        let tempMenus = resp.data.info.menus
                        let tempMenu = (tempMenus != null && tempMenus.length > 0)?tempMenus[0]:null
                        menuName = tempMenu.name
                        while (tempMenu != null && tempMenu.children != null && tempMenu.children.length > 0){
                            let first = tempMenu.children[0]
                            if(first.path != null){
                                redirectPath = first.path
                                break
                            }else {
                                tempMenu = first
                            }
                        }
                    }
                    this.$store.commit('addKey', menuName);
                    try {
                        if(this.$route.query.redirect){
                            let url =this.$route.query.redirect;
                            this.$router.push({path: url});
                        }else{
                            this.$router.push({path: redirectPath});
                        }
                    }catch(err){
                        this.$router.push({path: redirectPath});

                    }
                }
            }).catch(resp => {
                console.log(resp)
            })
        },
    }
}
</script>

<style scoped>
/* html,body{ height:100%; } */
#app {
    height: 100%; /*必须要加*/
}

#bg-img {
    background: url("../assets/background.jpg");
    width: 100%;
    height: 100%;
    position: fixed;
    background-size: 100% 100%;
}

.login_container {
    border: 1px solid #eaeaea;
    border-radius: 10%;
    margin: auto;
    width: 60%;
    height: 60%;
    padding: 35px 35px 35px 35px;
    box-shadow: 0 0 25px #cac6c6;
    background-clip: padding-box;
    /* background-color: rgba(0, 0, 0,0.7); */
    background-color: black;
    opacity: 0.7;
    display: flex;
    justify-content: center;
    align-items: stretch;
    align-content: stretch;
    flex-direction: column;
    flex-wrap: wrap;
}

.login_title {
    /* margin: 0 auto 40px auto; */
    font-size: larger;
    color: white;
}

    .background{
        width:100%;
        height:100%;
        z-index:-1;
        position: absolute;
    }

    .front{
        z-index:10;
        /* position: absolute; */
        /* left: 37%; */
        /* top: 5%; */
    }
    .el-row {
        height: 100%;
    }
    .main-class{
        height: 100%;
        /* overflow:hidden; */
    }
</style>
